/**
 * 埋码管理相关服务
 * Bai.Zhiming
 * 2019-6-18
 */
angular.module('hiddenCodeManagementServiceModule', [
    'hCreateClassifyModule'
]).
factory('hiddenCodeManagementService', ['$modal', 'modalDialog', 'trsHttpService', '$q', function($modal, modalDialog, trsHttpService, $q) {
    return {
        /**
         * [createClassify description] 创建分类
         * @return {[type]} [description]
         */
        createClassify(parentclassify) {
            let deffer = $q.defer();
            let modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/hiddenCodeManagement/services/createClassify/createClassify_tpl.html",
                windowClass: "h_create_classify",
                backdrop: false,
                controller: "hCreateClassifyCtrl",
                resolve: {
                    parentclassify() {
                        return parentclassify
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            }, function() {
                deffer.reject("cancle");
            });
            return deffer.promise;
        },
        /**
         * [treeLocation description] 树定位
         * @param  {[type]} path         [description] 节点路径
         * @param  {[type]} treeModel    [description] 树数据
         * @param  {[type]} selectedNode [description] 选中节点
         * @param  {[type]} expandedNode [description] 展开节点
         * @return {[type]}              [description]
         */
        treeLocation(path, treeModel, selectedNode, expandedNode, success) {
            let self = this;
            if (path == "") {
                success(selectedNode);
            }
            let pathArray = path.split(",");
            let thePath = pathArray[0];
            for (let j = 0; j < treeModel.length; j++) {
                let node = treeModel[j];
                if (node.id == thePath) {
                    getNodeChildren(node).then(() => {
                        expandedNode.push(node);
                        selectedNode = node;
                        pathArray.splice(0, 1)
                        this.treeLocation(pathArray.join(","), node.CHILDREN, selectedNode, expandedNode, success);
                    });
                    break;
                }
            }
            /**
             * [getNodeChildren description] 获取子节点
             * @param  {[Object]} node [parentNode] 父节点
             * @return {[type]} [description]
             */
            function getNodeChildren(parentNode) {
                let deffer = $q.defer();
                if (parentNode.CHILDREN) {
                    deffer.resolve();
                } else {
                    let params = {
                        serviceid: 'mlf_buridecode',
                        methodname: 'get',
                        parentid: parentNode.id
                    };
                    self.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(resp => {
                        parentNode.CHILDREN = resp.data
                        deffer.resolve();
                    });
                }
                return deffer.promise;
            }
        },
        /**
         * [httpServer description] 埋码管理，接口请求  增加拦截规则
         * @param  {[type]} url    [description]
         * @param  {[type]} params [description]
         * @param  {[type]} method [description]
         * @return {[type]}        [description]
         */
        httpServer(url, params, method, forbidden) {
            let deffer = $q.defer();
            trsHttpService.httpServer(url, params, method, forbidden).then(resp => {
                if (angular.isObject(resp) && resp.success == false) {
                    if (forbidden) {
                        deffer.reject(resp);
                    } else {
                        modalDialog.alertType(resp.message, "", "error", "confirm", () => {
                            deffer.reject(resp);
                        });
                    }
                } else {
                    deffer.resolve(resp);
                }
            }, resp => {
                deffer.reject(resp);
            });
            return deffer.promise;
        }
    };
}]);